import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import HomePage from './pages/HomePage';
import PaymentPage from './pages/PaymentPage';
import SuccessStoriesPage from './pages/SuccessStoriesPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AuthCallback from './pages/AuthCallback';
import StorePage from './pages/StorePage';
import StoreSuccessPage from './pages/StoreSuccessPage';
import ContentViewerPage from './pages/ContentViewerPage';
import AdminStorePage from './pages/AdminStorePage';
import AdminEnquiriesPage from './pages/AdminEnquiriesPage';
import { Toaster } from './components/ui/sonner';

// Router component that handles auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (Google OAuth callback)
  // This must be checked synchronously during render to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/success-stories" element={<SuccessStoriesPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/store" element={<StorePage />} />
      <Route path="/store/success" element={<StoreSuccessPage />} />
      <Route path="/store/view" element={<ContentViewerPage />} />
      <Route path="/store/admin" element={<AdminStorePage />} />
      <Route path="/admin/enquiries" element={<AdminEnquiriesPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
